import { createSelector } from "@reduxjs/toolkit";

import { getNodeSlotId, type GetNodeSlotId } from "../querying/index.ts";
import {
  nodeDesignsParentIdByChildIdSelector,
  nodeDesignsSlotsByParentIdSelector,
} from "./nodeDesignsCoreSelectors.ts";
import { nodeIdParamSelector } from "./paramSelectors.ts";

export const getNodeSlotIdSelector = createSelector(
  [nodeDesignsParentIdByChildIdSelector, nodeDesignsSlotsByParentIdSelector],
  (parentIdByChildId, slotsByParentId): GetNodeSlotId =>
    (nodeId: number) =>
      getNodeSlotId(parentIdByChildId, slotsByParentId, nodeId),
);

export const nodeSlotIdSelector = createSelector(
  [nodeDesignsParentIdByChildIdSelector, nodeDesignsSlotsByParentIdSelector, nodeIdParamSelector],
  (parentIdByChildId, slotsByParentId, nodeId) => getNodeSlotId(parentIdByChildId, slotsByParentId, nodeId),
);
